import { gql } from '@apollo/client';

export const GET_BULK_IMPORT_LOG_CSV = gql`
  query BulkUploadCSV($input: BulkUploadCSVInput) {
    bulkUploadCSV(input: $input) {
      blob
    }
  }
`;
